<template>
    <section class="columnar" id="myColumnarEcharts">
    </section>
</template>

<style lang="scss" scoped="scoped">
    .columnar {
        width: 100%;
        height: 100%;
        display: inline-flex;
    }
</style>

<script>
    export default {
        components: {

        },
        data () {
        	return {
        		myChart: {}
            }
        },
        props: ["columnarData"],
        computed: {
        	getOption () {
        		let opt = {
        			tooltip: {
        				show: true,
                        backgroundColor: 'rgba(255, 255, 255, .92)',
                        textStyle: {
        					color: '#142C3D'
                        },
                        extraCssText: 'box-shadow: 0 1px 18px 0 rgba(151, 189, 208, .3);'
                    },
                    grid: {
        				left: '2%',
                        right: '2%',
                        top: '2%',
                        bottom: '2%',
	                    containLabel: true
                    },
                    xAxis: {
        				type: 'value',
                        axisLine: {
        					lineStyle: {
        						color: '#E9EEF0'
                            }
                        },
                        axisLabel: {
        					color: '#6E808B'
                        },
                        splitLine: {
        					lineStyle: {
        						color: '#E9EEF0'
                            }
                        }
                    },
                    yAxis: {
        				type: 'category',
                        data: ['被支付商品数', '被下单商品数', '被浏览商品数', '在售商品数'],
	                    axisLine: {
		                    lineStyle: {
			                    color: '#E9EEF0'
		                    }
	                    },
	                    axisLabel: {
		                    color: '#142C3D',
                            fontSize: 14
	                    }
                    },
                    series: [
                        {
                        	name: '数量',
                            type: 'bar',
                            data: this.columnarData,
                            itemStyle: {
                        		normal: {
                        			color: '#26ABFF'
                                }
                            },
                            barWidth: '50%'
                        }
                    ]
                }
                return opt;
            }
        },
        watch: {
        	'columnarData' () {
        		this.changeEcharts();
            }
        },
        methods: {
            setEcharts () {
                let dom = document.getElementById('myColumnarEcharts');
                this.myChart = echarts.init(dom);
                this.myChart.setOption(this.getOption);
            },
            changeEcharts () {
            	this.myChart.setOption(this.getOption);
            }
        },
        mounted () {
        	this.setEcharts();
        }
    }
</script>



// WEBPACK FOOTER //
// Columnar.vue?5f24f8c8